import React from 'react';

const Footer: React.FC = () => {
	return (
		<div>
			<div className="aside">
				<div className="container">
					<div className="columns four">
						<a
							href="/"
							className="footer_logo">
							Scorpio Classics
						</a>
						<div className="copyright_text">
							We hope you enjoy browsing our website and look forward to any
							phone calls or a visit to our site in Warwickshire.
						</div>
						<div className="copyright">
							© Scorpio Classics 2025.
							<br />
							All rights reserved.
						</div>
					</div>
					<div className="columns four">
						<h5>Browse</h5>
						<ul className="aside_list">
							<li>
								<a href="/categories/Bikes">Bikes</a>
							</li>
							<li>
								<a href="/categories/Cars">Cars</a>
							</li>
							<li>
								<a href="/categories/Juke%20Boxes">Juke Boxes</a>
							</li>
						</ul>
					</div>
					<div className="columns four">
						<h5>Browse</h5>
						<ul className="aside_list">
							<li>
								<a href="/categories/Collectibles">Collectibles</a>
							</li>
							<li>
								<a href="/categories/Coins">Coins</a>
							</li>
							<li>
								<a href="/categories/Signs">Signs</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<footer>
				<div className="footer"></div>
			</footer>
		</div>
	);
};

export default Footer;
